import { render } from "./ResourceWebSearchDialog.vue?vue&type=template&id=38877db0&scoped=true"
import script from "./ResourceWebSearchDialog.vue?vue&type=script&lang=js"
export * from "./ResourceWebSearchDialog.vue?vue&type=script&lang=js"

import "./ResourceWebSearchDialog.vue?vue&type=style&index=0&id=38877db0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38877db0"]])

export default __exports__